<div class="mt-4 mb-2 row">
  <div class="col-12 col-sm-3 col-md-2">
    Всего: <b>{{count}}</b>
  </div>
</div>
@if (modal_show) {
  <app-modal [caption]="'JSON текст'" (onClosed)="modalClose()">
    <pre>{{modal_content|json}}</pre>
  </app-modal>
}
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'">
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>
            <p>{{row['create_time']}}</p>
          </td>
          <td>
            <a href="/reservation/lead-info/{{row.lead_id}}"
              (click)="goBack.newLink('/reservation/lead-info/' + row.lead_id, 'appeal_client_fio-' + row.lead_id, $event)">
              @if (row.sale_developer_id) {
                {{row.physical_caption}} &mdash; {{row.sale_developer_caption}}
              }
              @if (!row.sale_developer_id) {
                {{row.physical_caption}} &mdash; {{row.lead_realty_caption}}
              }
            </a>
          </td>
          <td>
            <p>{{row['method']}}</p>
          </td>
          <td>
            @if (row['params']) {
              <a class="" href="javascript: void(0)"
                (click)="viewLogParam(row['params'], $event)">
                Подробнее
              </a>
            }
          </td>
          <td>
            <p>{{row['remote_addr']}}</p>
          </td>
          <td>
            <p>{{row['user_platform']}}</p>
          </td>
          <td>
            <p>{{row['user_browser']}}</p>
          </td>
          <td>
            @if (row['user_detail']) {
              <a class="" href="javascript: void(0)"
                (click)="viewLogParam(row['user_detail'], $event)">
                Подробнее
              </a>
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>
<div class="alt-pagination">
  <app-paginator
    [itemsPerPage]="50"
    [itemCount]="count"
    [currentPage]="current_page"
    [baseUrl]="'/est-card-log'">
  </app-paginator>
</div>
